import { apiClient } from "../lib/api";

export const invitationApi = {
  create: (payload) => apiClient.post("/invitations", payload),
  list: () => apiClient.get("/invitations"),
  revoke: (id) => apiClient.post(`/invitations/${id}/revoke`),
  markCopied: (id) => apiClient.post(`/invitations/${id}/mark-copied`),
  markDelivered: (id) => apiClient.post(`/invitations/${id}/mark-delivered`),
  validate: (token) => apiClient.get("/invitations/validate", { params: { token } }),
  accept: (token, password) => apiClient.post("/invitations/accept", { token, password }),
};
